module.exports = __webpack_public_path__ + "img/job-dashboard-hover.657b0db6.svg";